import { CFAuthGet } from "auth";

export default async (stateCode) => {
  return await CFAuthGet({
    url: `${process.env.REACT_APP_AP_API_URL}/AgentVerification/Mappings/GetCities/${stateCode}`,
    originURL: process.env.PUBLIC_URL,
    loaderName: ''
  });
}


// WEBPACK FOOTER //
// ./src/features/agent-info-verification/api/getCities.js